import { useState } from "preact/hooks";

type ValidationState =
  | { state: "IDLE" }
  | { state: "VALIDATING" }
  | { state: "VALID" }
  | { state: "INVALID"; error: string };

export function SSO({
  changeSignInMode,
  onValidInitialize,
  getSSORedirectUrl,
}: {
  changeSignInMode?: () => void;
  onValidInitialize: (ssoURL: string) => void;
  getSSORedirectUrl: (email: string) => Promise<string>;
}) {
  const [validation, setValidation] = useState<ValidationState>({
    state: "IDLE",
  });

  return (
    <div class="csb-api-gDXMLZ csb-api-iaWCwi" style={{ opacity: 1 }}>
      <h1 class="csb-api-gDXMLZ csb-api-efjlMo csb-api-gHixVw" id="heading">
        Sign in with SSO
      </h1>
      <form
        class="csb-api-gDXMLZ csb-api-bsZwCf csb-api-iPhhHK"
        onSubmit={async (e) => {
          e.preventDefault();
          const formData = new FormData(e.target as HTMLFormElement);
          const email = formData.get("email")?.toString();

          if (!email) {
            return;
          }

          if (!email) {
            return;
          }
          setValidation({ state: "VALIDATING" });

          try {
            const redirectUrl = await getSSORedirectUrl(email);
            onValidInitialize(redirectUrl);
            setValidation({ state: "VALID" });
          } catch (err) {
            setValidation({ state: "INVALID", error: String(err) });
          }
        }}
      >
        <div class="csb-api-gDXMLZ csb-api-fygrRn">
          <div class="csb-api-gDXMLZ csb-api-bSzsUN">
            <input
              aria-describedby="error"
              aria-labelledby="heading"
              class="csb-api-gDXMLZ csb-api-CmLhy csb-api-ejERkE"
              disabled={validation.state !== "IDLE"}
              name="email"
              placeholder="Enter your email"
              type="email"
              required
            />
            <div class="csb-api-gDXMLZ csb-api-jWVHRd">
              {
                /*
                {
                  VALID: <Icon css={{ color: '#B3FBB4' }} name="simpleCheck" />,
                  INVALID: (
                    <Icon css={{ color: '#ED6C6C' }} name="infoOutline" />
                  ),
                }[validation.state]
              }
              */
                {
                  VALID: null,
                  INVALID: null,
                  IDLE: null,
                  VALIDATING: null,
                }[validation.state]
              }
            </div>
          </div>
          <div aria-live="polite" class="csb-api-gDXMLZ" id="error">
            {validation.state === "INVALID" ? (
              <span class="csb-api-gDXMLZ csb-api-efjlMo csb-api-gFehFv">
                {changeSignInMode ? (
                  <>
                    Request failed with status code 422. Please contact your
                    team admin or{" "}
                    <button
                      class="csb-api-hjGqFO csb-api-eYNxpT"
                      onClick={changeSignInMode}
                      type="button"
                    >
                      sign in through a different method
                    </button>
                    .
                  </>
                ) : (
                  <>
                    Request failed with status code 422. Please contact your
                    team admin.
                  </>
                )}
              </span>
            ) : null}
          </div>
        </div>
        <button
          class="csb-api-gFUkTC csb-api-iMjrFU csb-api-fWRCGd"
          disabled={validation.state !== "IDLE"}
          type="submit"
        >
          <span class="csb-api-gDXMLZ csb-api-bGdKhk csb-api-cIOuzf">
            {["VALIDATING", "VALID"].includes(validation.state)
              ? "Signin in..."
              : "Continue with SSO"}
          </span>
        </button>
      </form>
    </div>
  );
}
